import DotLegalDeleteDialogWrapper from "@common/components/dotLegalDeleteDialog/DotLegalDeleteDialogWrapper";
import { RiskConsequenceViewModel } from "../RiskConsequences.types";
import { DeleteRiskConsequenceDialogDataMapping } from "./DeleteRiskConsequenceDialog.hooks";

export interface IDeleteRiskConsequenceDialog {
    onCloseDialog: () => void;
    onDeletion: () => void;
    selectedRiskConsequence: RiskConsequenceViewModel;
}

export function DeleteRiskConsequenceDialog(props: IDeleteRiskConsequenceDialog) {
    const { removeRiskConsequence, inProgress } = DeleteRiskConsequenceDialogDataMapping(props);

    return (
        <DotLegalDeleteDialogWrapper
            open
            itemForDeletion={props.selectedRiskConsequence.name}
            onDialogClose={props.onCloseDialog}
            onOkClick={removeRiskConsequence}
            inProgress={inProgress}
        />
    );
}
